(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stage-products"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-sp-scroll]');
    if (!button) return;
    const track = document.getElementById(button.dataset.spTarget);
    if (!track) return;
    const card = track.querySelector('.sp-card');
    const step = card ? card.getBoundingClientRect().width + 12 : track.clientWidth * 0.6;
    track.scrollBy({ left: step * Number(button.dataset.spScroll), behavior: 'smooth' });
  });

  } catch(e) { console.error(e); }
})();
})();
